import Vue from 'vue';
import { AppConstants } from './app.constants';
import axios from 'axios';
import { Setting, ConfigKeys } from './types';

export class Utils {
    static readonly defaultToastConfig = {
        duration: 5000,
        singleton: true,
    };

    static toQueryString = (obj: object) => {
        return Object.keys(obj)
            .map(function(key) {
                return key + '=' + obj[key];
            })
            .join('&');
    };

    static inIframe() {
        return window.self !== window.top;
    }

    static fromQueryString = (queryString: string): object => {
        let params = {},
            queries,
            temp,
            i,
            l;
        queries = queryString.split('&');

        for (i = 0, l = queries.length; i < l; i++) {
            temp = queries[i].split('=');
            params[temp[0]] = temp[1];
        }
        return params;
    };

    static toastSuccess = (message: string, config?: object) => {
        Vue['toasted'].success(
            message || '',
            config || Utils.defaultToastConfig
        );
    };

    static toastError = (message: string, config?: object) => {
        Vue['toasted'].error(message || '', config || Utils.defaultToastConfig);
    };
    static jsonParse<T>(jsonString: string): T {
        try {
            var object = JSON.parse(jsonString);
            return object as T;
        } catch (e) {
            return null;
        }
    }

    static trySetLanguage = (): void => {
        try {
            const haveSetLanguage =
                localStorage.getItem(
                    AppConstants.LocalStorageKeys.HAVE_SET_LANGUAGE
                ) || '';
            const canSetLanguage =
                haveSetLanguage.toLowerCase().trim() !== 'true';

            if (canSetLanguage) {
                localStorage.setItem(
                    AppConstants.LocalStorageKeys.HAVE_SET_LANGUAGE,
                    'true'
                );

                let browserLanguage = navigator.language || '';
                browserLanguage = browserLanguage.toLowerCase().trim();

                if (browserLanguage.includes('es')) {
                    document.cookie = 'googtrans=/en/es';
                } else if (browserLanguage.includes('zh')) {
                    document.cookie = 'googtrans=/en/zh-CN';
                } else if (browserLanguage.includes('fr')) {
                    document.cookie = 'googtrans=/en/fr';
                }
            }
        } catch (e) {}
    };
    static async fetchSetting(configKey: ConfigKeys): Promise<Setting> {
        const res = await axios.get(
            `${process.env.VUE_APP_API_URI}/api/admin/setting/${configKey}`
        );
        const cfg = {
            ...res.data,
            dateCreated: res.data.dateCreated && new Date(res.data.dateCreated),
            dateUpdated: res.data.dateUpdated && new Date(res.data.dateUpdated),
            dateDeleted: res.data.dateDeleted && new Date(res.data.dateDeleted),
        };

        return cfg;
    }

    static async updateSetting(cfg: Setting): Promise<Setting> {
        const res = await axios.post(
            `${process.env.VUE_APP_API_URI}/api/admin/setting`,
            cfg
        );

        return res.data;
    }

    static isRowOld(params): string {
        if (!params.data || !params.data.timestamp) {
            return '';
        }

        const now = new Date();

        const dateSubmitted = new Date(params.data.timestamp);

        const diff = now.getTime() - dateSubmitted.getTime();

        // msecs * secs * minutes * hour * 1/2 year's days
        const months6 = (1000 * 60 * 60 * 24 * 365) / 2;

        if (diff >= months6) {
            return 'old';
        }

        return '';
    }

    static formatEmployerName(googlePlace): string {
        const empName = googlePlace.name;
        const comps = googlePlace.address_components;

        const segs = [
            comps.find(comp => comp.types.includes('street_number')),
            comps.find(comp => comp.types.includes('route')),
            comps.find(comp => comp.types.includes('locality')),
            comps.find(comp =>
                comp.types.includes('administrative_area_level_1')
            ),
            comps.find(comp => comp.types.includes('postal_code')),
        ]
            .map((seg, i) => {
                if (seg) {
                    let name = seg.long_name;
                    if ([1, 2].includes(i)) {
                        name += ',';
                    }

                    return name;
                }

                return undefined;
            })
            .filter(seg => Boolean(seg))
            .join(' ');

        return empName + ' - ' + segs;
    }
}
